import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()(() => ({
  root: {
    display: "flex",
    justifyContent: "start",
    gap: 16,
    padding: 8,
  },
  label: {
    fontSize: "0.875rem",
    maxWidth: 400,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  btnRemove: {
    backgroundColor: "var(--bg-secondary-light)",
    width: 24,
    height: 24,
  },
  rolesGroup: {
    marginLeft: 12,
    display: "flex",
    gap: 8,
  },
  role: {
    borderRadius: 8,
    backgroundColor: "var(--color-supp-light)",
    fontSize: "0.875rem",
    padding: "4px 8px",
    lineHeight: "normal",
    alignSelf: "center",
    textAlign: "center",
    cursor: "pointer",
  },
  roleActive: {
    color: "var(--bg-white)",
    backgroundColor: "var(--color-primary)",
  },
}));
